module.exports = __webpack_public_path__ + "img/9-climb_v8e.91014c64.png";